<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><k-dialog v-model="dialog_open" persistent max-width="800px"><k-card>
	<k-card-title>
		<div>Add New User Record</div>
	</k-card-title>
	<k-card-text style="color:#000;">
		<div>Enter an email, first name, and last name to create a user record. The user will have standard “staff” rights; you can then give the user additional site priviledges if you wish.</div>
		<div class="mt-3"><k-text-field dense outlined hide-details label="Email Address" v-model="email"></k-text-field></div>
		<div class="mt-3"><k-text-field dense outlined hide-details label="First Name" v-model="first_name"></k-text-field></div>
		<div class="mt-3"><k-text-field dense outlined hide-details label="Last Name" v-model="last_name"></k-text-field></div>
		<div class="mt-3"><k-text-field dense outlined hide-details label="Initial Password (user can change this after signing in)" v-model="password"></k-text-field></div>
	</k-card-text>
	<k-card-actions class="pl-4 pr-4 pb-4">
		<k-btn color="secondary" @click="cancel_clicked" class="mr-1"><k-icon small class="mr-2">fas fa-times</k-icon> Cancel</k-btn>
		<k-btn color="primary" @click="save_edits" class="k-tight-btn"><k-icon small class="mr-2">fas fa-check</k-icon> Create User Record</k-btn>
	</k-card-actions>
</k-card></k-dialog></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	components: { },
	props: {
	},
	data() { return {
		dialog_open: true,
		first_name: '',
		last_name: '',
		email: '',
		password: '',
	}},
	computed: {
		...mapState(['user_info']),
	},
	created() {
		// this.system_role = this.user.system_role
	},
	mounted() {
		// DEBUG
		vapp.user_edit = this
	},
	methods: {
		show_help() { vapp.show_help('roles_system') },

		save_edits(flag) {
			this.first_name = $.trim(this.first_name)
			this.last_name = $.trim(this.last_name)
			this.email = $.trim(this.email)
			this.password = $.trim(this.password)
			if (empty(this.email) || empty(this.first_name) || empty(this.last_name)) {
				this.$alert('You must specify an email address and the first and last name for the user.')
				return
			}

			let payload = {
				user_id: this.user_info.user_id,
				email: this.email,
				first_name: this.first_name,
				last_name: this.last_name,
			}
			if (!empty(this.password)) payload.password = this.password

			U.ajax('admin_create_user', payload, result=>{
				if (result.status != 'ok') {
					this.$alert(result.status)
				} else {
					this.$alert('User record successfully created.')
					this.cancel_clicked()
				}
			})
		},

		cancel_clicked() {
			this.$emit('editor_cancel')
		},
	}
}
</script>

<style lang="scss">
</style>
